import type { DateFnsFormat } from '../../models'

import { format } from './format'
import { toDestinationDate } from './toDestinationDate'

export const formatDestinationDate = (dateFormat: DateFnsFormat, date: Date | string): string =>
  format(dateFormat, toDestinationDate(date))
